import React, { useEffect, useState, useRef } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";

import { useLocation } from "react-router-dom";

import { BoxFiltroScorecardGerente } from "./BoxFiltroScorecardGerente";
import { useBox, } from "./Helper/useBox";
import { GetKey } from "./Actions/GetContainer";
import Swal from "sweetalert2";
import { DashScorecardGerenteAsesorTable } from "./DashScoreardGerenteAsesorTable";
import { TablaImportesScorecardGerente } from "./TablaImportesScorecardGerente";
import { TablaGerenteImporteAsesor } from "./TablaGerenteImporteAsesor";
import { TablaUnidadesScorecardGerente } from "./TablaUnidadesScorecardGerente";
import { useSelector } from "react-redux";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


export const DashScorecardGerenteScreen = () => {
  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const history = useHistory();
  const helpRef = useRef(null);

  const [data, setData] = useState([]);
  const [dataImportes, setDataImportes] = useState([]);
  const [dataAsesores, setDataAsesores] = useState([]);
  // const [vendedores, setVendedores] = useState([]);
  const location = useLocation();
  const { state } = location;
  const { empleado } = useSelector((store) => store.usuario);
  const [vendedorSeleccionado, setVendedorSeleccionado] = useState(null);
  const [tipoUsuario, setTipoUsuario] = useState([]);
  const [selectedValues, setSelectedValues] = useState({
    region: 0,
    sucursal: 0,
    vendedor: 0,
  });
  const [mostrarTUnidades, setMostrarTUnidades] = useState(true);
  const [mostrarTImportes, setMostrarTImportes] = useState(false);
  const [mostrarTAUnidades, setMostrarTAUnidades] = useState(false);
  const [mostrarTAImportes, setMostrarTAImportes] = useState(false);
  const [titulo, setTitulo] = useState("SCORECARD GENERAL");

  const [openHelp, setOpenHelp] = useState(false);


  const fechaActual = new Date();
  const ejercicioActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1;

  const initialStateboxfiltros = () => {
    const datosFiltro = localStorage.getItem("DatosFiltro");
    // console.log(datosFiltro)

    if (datosFiltro) {
      const filtroParsed = JSON.parse(datosFiltro);
      return {
        ejercicioinicio: filtroParsed.ejercicioinicio || ejercicioActual,
        periodoinicio: filtroParsed.periodoinicio || "1",
        ejerciciofin: filtroParsed.ejerciciofin || ejercicioActual,
        periodofin: filtroParsed.periodofin || mesActual,
        tabla: "A",
        comparativa: ejercicioActual - 1,
        visualizacion: filtroParsed.visualizacion,
        pv: {
          adr: filtroParsed.pv.adr || [],
          sucursal: filtroParsed.pv.sucursal || [],
          vendedor: filtroParsed.pv.vendedor || [],
        },
      };
    } else {
      return {
        ejercicioinicio: ejercicioActual,
        periodoinicio: "1",
        ejerciciofin: ejercicioActual,
        periodofin: mesActual,
        tabla: "A",
        mostrarcomparativo: "N",
        comparativa: ejercicioActual - 1,
        visualizacion: "U",
        pv: { adr: [], sucursal: [], vendedor: [] },
      };
    }
  };

  // const boxstatelocal = initialStateboxfiltros();
  const [boxstate, setBoxState] = useBox(initialStateboxfiltros());




  const idEstadop =
    boxstate.pv.adr.length > 1 ? 0 : boxstate.pv.adr[0]?.idEstado || 0;

  // Establece idSucursal como 0 si hay más de un elemento en sucursal
  const idSucursalp =
    boxstate.pv.sucursal.length > 1
      ? 0
      : boxstate.pv.sucursal.length > 0
        ? boxstate.pv.sucursal[0]?.idSucursal
        : null;

  // Establece idEmpleado como 0 si hay más de un elemento en vendedor

  // Asignar 0 si es null
  const finalIdSucursal = idSucursalp === null ? 0 : idSucursalp;

  const vendedores = boxstate.pv.vendedor;
  const primerVendedor = vendedores.length > 0 ? vendedores[0] : null;

  const idEmpleadop =
    vendedores.length > 1
      ? 0
      : primerVendedor
        ? primerVendedor.idvendedor ?? 0
        : null;

  const finalIdEmpleado = idEmpleadop !== null ? idEmpleadop : 0;

  const { idvendedor, vendedor } = state || {};

  const onHome = () => {
    localStorage.removeItem("DatosFiltro");
    history.push("/Home/Dashboard");
  };


  const onDetalleMensual = (linea) => {
    // Verificar si hay datos en localStorage para 'DatosFiltro'
    const datosFiltro = localStorage.getItem("DatosFiltro");

    // Si hay datos en localStorage, usar initialStateboxfiltros(); de lo contrario, usar boxstate
    const data = {
      boxstate: datosFiltro ? initialStateboxfiltros() : boxstate,
      linea,
    };

    // Eliminar el item 'DatosFiltro' del localStorage
    localStorage.removeItem("DatosFiltro");

    // Navegar a la ruta especificada, pasando el objeto data en el estado
    history.push({
      pathname: "/Ventas/DetalleFacturacionMensual",
      state: data,
    });
  };

  const onDetalleAcumulado = (linea) => {
    // Verificar si hay datos en localStorage para 'DatosFiltro'
    const datosFiltro = localStorage.getItem("DatosFiltro");

    // Si hay datos en localStorage, usar initialStateboxfiltros(); de lo contrario, usar boxstate
    const data = {
      boxstate: datosFiltro ? initialStateboxfiltros() : boxstate,
      linea,
    };

    // Eliminar el item 'DatosFiltro' del localStorage
    localStorage.removeItem("DatosFiltro");

    history.push({
      pathname: "/Ventas/DetalleFacturacionAcumulado",
      state: data,
    });
  };


  const getMonth = () => {
    const date = new Date();
    return date.getMonth() + 1;
  };
  var mes_actual = getMonth();

  const peticionesActivas = useRef(0);

  const iniciarCarga = () => {
    peticionesActivas.current += 1;
    setLoader((prev) => ({ ...prev, mostrar: true }));
  };

  const terminarCarga = () => {
    peticionesActivas.current = Math.max(0, peticionesActivas.current - 1);

    // Solo apagamos el loader cuando YA NO queda ninguna petición pendiente
    if (peticionesActivas.current === 0) {
      // Doble requestAnimationFrame: espera a que React haga commit
      // Y a que el navegador PINTE la tabla antes de quitar el loader.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setLoader((prev) => ({ ...prev, mostrar: false }));
        });
      });
    }
  };
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    iniciarCarga();
    request
      .get("SeleccionarScorecard/usuario")
      .then((result) => {
        const userInfo = result[0];
        setTipoUsuario(userInfo);
      })
      .catch(() => { })
      .finally(() => terminarCarga());
  }, []);

  useEffect(() => {
    BoxClick()

  }, []);

  useEffect(() => {
    iniciarCarga();
    request
      .get(`ListadoVendedoresDash/Obtener_Vendedores`)
      .then((result) => {
        // setVendedores([{ idempleado: 0, empleado: 'Consolidado' }, ...result])
      })
      .catch((error) => {
        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
      })
      .finally(() => terminarCarga());
  }, []);

  const construirTitulo = () => {
    const mesInicio = meses[boxstate.periodoinicio - 1];
    const mesFin = meses[boxstate.periodofin - 1];

    let tituloP = "SCORECARD GENERAL ";

    if (
      boxstate.periodoinicio !== boxstate.periodofin &&
      boxstate.ejercicioinicio !== boxstate.ejerciciofin
    ) {
      tituloP += `${mesInicio} ${boxstate.ejercicioinicio} - ${mesFin} ${boxstate.ejerciciofin}`;
    } else if (
      mesInicio === mesFin &&
      boxstate.ejercicioinicio !== boxstate.ejerciciofin
    ) {
      tituloP += `${mesInicio} ${boxstate.ejercicioinicio} - ${boxstate.ejerciciofin}`;
    } else if (
      mesInicio !== mesFin &&
      boxstate.ejercicioinicio === boxstate.ejerciciofin
    ) {
      tituloP += `${mesInicio} - ${mesFin} ${boxstate.ejercicioinicio}`;
    } else {
      tituloP += `${mesInicio} - ${boxstate.ejercicioinicio}`;
    }

    return tituloP;
  };

  const BoxClick = async () => {
    const estaVacio = (v) =>
      v === undefined || v === null || v === "" || v === "0" || v === 0;

    // ---------- VALIDACIONES (antes de encender el loader) ----------
    if (estaVacio(boxstate.ejercicioinicio)) {
      Swal.fire("SCORECARD", "Favor de agregar el ejercicio de inicio", "warning");
      return;
    }
    if (estaVacio(boxstate.periodoinicio)) {
      Swal.fire("SCORECARD", "Favor de agregar el periodo de inicio", "warning");
      return;
    }
    if (estaVacio(boxstate.ejerciciofin)) {
      Swal.fire("SCORECARD", "Favor de agregar el ejercicio fin", "warning");
      return;
    }
    if (Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)) {
      Swal.fire(
        "SCORECARD",
        "El ejercicio de inicio debe ser menor o igual al ejercicio final",
        "warning"
      );
      return;
    }
    if (estaVacio(boxstate.periodofin)) {
      Swal.fire("SCORECARD", "Favor de indicar el periodo final", "warning");
      return;
    }
    if (
      Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
      Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
    ) {
      Swal.fire(
        "SCORECARD",
        "El periodo de inicio no puede ser mayor al periodo fin",
        "warning"
      );
      return;
    }

    iniciarCarga();

    try {
      // ---------- localStorage ----------
      const datosFiltros = JSON.parse(localStorage.getItem("DatosFiltro"));
      if (datosFiltros) {
        datosFiltros.ejercicioinicio = boxstate.ejercicioinicio;
        datosFiltros.periodoinicio = boxstate.periodoinicio;
        datosFiltros.ejerciciofin = boxstate.ejerciciofin;
        datosFiltros.periodofin = boxstate.periodofin;
        datosFiltros.pv = {
          adr: boxstate.pv.adr || [],
          sucursal: boxstate.pv.sucursal || [],
          vendedor: boxstate.pv.vendedor || [],
        };
        localStorage.setItem("DatosFiltro", JSON.stringify(datosFiltros));
      }

      // ---------- Parámetros ----------
      let sucursales = GetKey(boxstate.pv.sucursal, ["idSucursal"]);
      if (!sucursales) sucursales = "0";

      let vendedoresParam = GetKey(boxstate.pv.vendedor, ["idvendedor"]);
      if (!vendedoresParam) vendedoresParam = "0";

      const parametros =
        `region=${idEstadop}` +
        `&sucursal=${sucursales}` +
        `&vendedor=${vendedoresParam}` +
        `&ejercicioinicio=${boxstate.ejercicioinicio}` +
        `&periodoinicio=${boxstate.periodoinicio}` +
        `&ejercicio=${boxstate.ejerciciofin}` +
        `&mes_actual=${boxstate.periodofin}`;

      let url = null;
      if (boxstate.tabla === "L") {
        url = `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?${parametros}`;
      } else if (boxstate.tabla === "A" && boxstate.visualizacion === "U") {
        url = `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametrosTablaAsesor?${parametros}&comparativa=${boxstate.comparativa}`;
      } else if (boxstate.tabla === "A" && boxstate.visualizacion === "I") {
        url = `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametrosTablaAsesorImportes?${parametros}&comparativa=${boxstate.comparativa}`;
      }

      if (!url) {
        Swal.fire(
          "SCORECARD",
          "No se encontró una vista válida para los filtros seleccionados",
          "warning"
        );
        return;
      }

      const result = await request.get(url);

      if (boxstate.tabla === "L" && boxstate.visualizacion === "U") {
        setData(result);
        setDataAsesores([]);
        setMostrarTUnidades(true);
        setMostrarTImportes(false);
        setMostrarTAUnidades(false);
        setMostrarTAImportes(false);
      } else if (boxstate.tabla === "L" && boxstate.visualizacion === "I") {
        setData([]);
        setDataImportes(result);
        setDataAsesores([]);
        setMostrarTUnidades(false);
        setMostrarTImportes(true);
        setMostrarTAUnidades(false);
        setMostrarTAImportes(false);
      } else if (boxstate.tabla === "A" && boxstate.visualizacion === "U") {
        setDataAsesores(result);
        setData([]);
        setMostrarTUnidades(false);
        setMostrarTImportes(false);
        setMostrarTAUnidades(true);
        setMostrarTAImportes(false);
        setTitulo(construirTitulo());
      } else if (boxstate.tabla === "A" && boxstate.visualizacion === "I") {
        setDataAsesores(result);
        setData([]);
        setMostrarTUnidades(false);
        setMostrarTImportes(false);
        setMostrarTAUnidades(false);
        setMostrarTAImportes(true);
        setTitulo(construirTitulo());
      }
    } catch (error) {
      Swal.fire("SCORECARD", JSON.stringify(error), "warning");
    } finally {
      terminarCarga();
    }
  };

  const onGeneraExcel = () => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    // return;
    setLoader({ ...loader, mostrar: true });
    if (boxstate.tabla === 'L' || boxstate.tabla === undefined) {
      request
        .get(
          `CargaScorecardporVendedorDash/ImprimirExcel?region=${idEstadop}&sucursal=${finalIdSucursal}&vendedor=${finalIdEmpleado}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    }
    else if (boxstate.tabla === 'A') {
      request
        .get(
          `CargaScorecardporVendedorDash/ImprimirExcelTablaAsesores?region=${idEstadop}&sucursal=${finalIdSucursal}&vendedor=${finalIdEmpleado}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    }
  };

  const onGeneraPDF = () => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    setLoader({ ...loader, mostrar: true });
    if (boxstate.tabla === 'L' || boxstate.tabla === undefined) {
      request
        .get(
          `CargaScorecardporVendedorDash/ImprimirPDF?region=${idEstadop}&sucursal=${finalIdSucursal}&vendedor=${finalIdEmpleado}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          const linkSource = `data:application/pdf;base64, ${result.documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${result.nombredocumento}.${result.extension}`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }

    else if (boxstate.tabla === 'A') {
      request
        .get(
          `CargaScorecardporVendedorDash/ImprimirPDFTablaAsesores?region=${idEstadop}&sucursal=${finalIdSucursal}&vendedor=${finalIdEmpleado}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          const linkSource = `data:application/pdf;base64, ${result.documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${result.nombredocumento}.${result.extension}`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  };

  const formatPorcentaje = (real, objetivo) => {
    if (objetivo === 0 && real === 0) {
      return null;
    }

    if (objetivo === 0) {
      return 100;
    }

    const porcentaje = (real / objetivo) * 100;

    return Math.min(porcentaje, 100);
  };

  const getBarColor = (porcentaje) => {
    if (porcentaje <= 60) {
      return "#f44336";
    } else if (porcentaje > 60 && porcentaje < 80) {
      return "#ffc107";
    } else {
      return "#035917";
    }
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <PlantillaScreen
        titulo={titulo}
        className_main={1}
        className={dataAsesores.length > 0 ? "filtro-scorecard-asesores-table" : "filtro-scorecard"}
      >
        <div className="dash-tabla-scorecard-gerente-actions">
          <div
            className="dash-tabla-scorecard-gerente-actions-regresar"
            onClick={() => onHome()}
          >
            <ArrowBackIcon /> Regresar
          </div>
          <BoxFiltroScorecardGerente
            boxState={boxstate}
            onBoxChange={setBoxState}
            BoxClick={BoxClick}
            datoslocal={initialStateboxfiltros()}
            // subtitulo={state.subtitulo}
            titulo_filtro="SCORECARD GENERAL"
          ></BoxFiltroScorecardGerente>

          <div className="buttons">
            <button className="excel" onClick={onGeneraExcel}>
              <i className=" icon-file-excel" /> Excel
            </button>
            <button
              className="PDF"
              onClick={onGeneraPDF}
              style={{ backgroundColor: "#940404" }}
            >
              PDF
            </button>
            <div style={{ position: "relative" }} ref={helpRef}>
              <button
                className="ayuda"
                onClick={() => setOpenHelp(!openHelp)}
              >
                <HelpOutlineIcon />
                Ayuda
              </button>

              {openHelp && (
                <div className="popover-help">
                  <div className="arrow"></div>

                  <div className="popover-titulo">
                    <div className="popover-header">
                      <div className="popover-header-titulo">{"Ayuda"}</div>
                    </div>
                    <div className="plantilla-screen-efecto">
                      <div className="plantilla-screen-efecto-bl"></div>
                      <div className="plantilla-screen-efecto-circle"></div>
                      <div className="plantilla-screen-efecto-br"></div>
                    </div>
                  </div>

                  <p className="texto">
                    Los siguientes indicadores están puntuados en base a la venta real
                    respecto al objetivo de la misma, quedando las ponderaciones de la
                    siguiente manera:
                  </p>

                  <div className="indicadores">
                    <div className="fila">
                      <span className="circulo verde"></span>
                      <span className="label-texto-asd">Mayor a 85%</span>
                    </div>

                    <div className="fila">
                      <span className="circulo amarillo"></span>
                      <span className="label-texto-asd">Entre a 65% y 85%</span>
                    </div>

                    <div className="fila">
                      <span className="circulo rojo"></span>
                      <span className="label-texto-asd">Menor 65%</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <LoaderScreen loader={loader} />
        {/* {mostrarTUnidades === true ? (
          <div className="dash-tabla-score-card-gerente-screen scroll-4">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th></th>
                  <th colSpan={3}>
                    <div>{GetMonthNameByNumber(boxstate.periodofin)}</div>
                  </th>
                  <th colSpan={3}>
                    <div>
                      {GetMonthNameByNumber(boxstate.periodoinicio)}{" "}
                      {boxstate.ejercicioinicio} a{" "}
                      {GetMonthNameByNumber(boxstate.periodofin)}{" "}
                      {boxstate.ejerciciofin}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    <div>Línea</div>
                  </th>
                  <th>
                    <div>Objetivo</div>
                  </th>
                  <th>
                    <div>Real</div>
                  </th>
                  <th>
                    <div>Alcance</div>
                  </th>
                  <th>
                    <div>Objetivo</div>
                  </th>
                  <th>
                    <div>Real</div>
                  </th>
                  <th>
                    <div>Alcance</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((score) => {
                  const porcentajeMensual = formatPorcentaje(
                    score.unidades_vendidas,
                    score.objetivo
                  );
                  const porcentajeAcumulado = formatPorcentaje(
                    score.unidades_vendidas_acumulado,
                    score.objetivo_acumulado
                  );
                  const barColorMensual = getBarColor(porcentajeMensual);
                  const barColorAcumulado = getBarColor(porcentajeAcumulado);

                  return (
                    <tr key={score.linea}>
                      <td>{capitalizeWords(score.linea)}</td>
                      <td onClick={() => onDetalleMensual(score.linea)}>
                        {score.objetivo}
                      </td>
                      <td onClick={() => onDetalleMensual(score.linea)}>
                        {score.unidades_vendidas}
                      </td>
                      <td onClick={() => onDetalleMensual(score.linea)}>
                        <span className="percentaje">
                          {score.objetivo !== 0 || score.unidades_vendidas !== 0
                            ? `${porcentajeMensual.toFixed(0)}%`
                            : ""}
                        </span>
                        <LinearProgress
                          variant="determinate"
                          value={porcentajeMensual}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#e0e0e0",
                            "& .MuiLinearProgress-bar": {
                              backgroundColor: barColorMensual,
                            },
                          }}
                        />
                      </td>
                      <td onClick={() => onDetalleAcumulado(score.linea)}>
                        {score.objetivo_acumulado}
                      </td>
                      <td onClick={() => onDetalleAcumulado(score.linea)}>
                        {score.unidades_vendidas_acumulado}
                      </td>
                      <td onClick={() => onDetalleAcumulado(score.linea)}>
                        <span className="percentaje">
                          {score.objetivo_acumulado !== 0 ||
                            score.unidades_vendidas_acumulado !== 0
                            ? `${porcentajeAcumulado.toFixed(0)}%`
                            : ""}
                        </span>
                        <LinearProgress
                          variant="determinate"
                          value={porcentajeAcumulado}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#e0e0e0",
                            "& .MuiLinearProgress-bar": {
                              backgroundColor: barColorAcumulado,
                            },
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
                <tr className="importes-totales">
                  <td>Importe Total</td>
                  <td>
                    {FormatMoney(
                      data.reduce(
                        (acumulador, item) =>
                          acumulador + item.importe_proyectado,
                        0
                      ),
                      0
                    )}
                  </td>
                  <td>
                    {FormatMoney(
                      data.reduce(
                        (acumulador, item) => acumulador + item.importe,
                        0
                      ),
                      0
                    )}
                  </td>
                  <td></td>
                  <td>
                    {FormatMoney(
                      data.reduce(
                        (acumulador, item) =>
                          acumulador + item.importe_proyectado_acumulado,
                        0
                      ),
                      0
                    )}
                  </td>
                  <td>
                    {FormatMoney(
                      data.reduce(
                        (acumulador, item) => acumulador + item.importe_acumulado,
                        0
                      ),
                      0
                    )}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        )  */}
        {mostrarTUnidades === true ? (
          <div className="dash-tabla-container">
            <div className="dash-filtro-usados-container">
              <div className="dash-filtro-usados-sucursal">
                <div className="dash-filtro-usado-titulo">
                  {boxstate.pv.sucursal.length === 0
                    ? "Adr: "
                    : "Sucursal:"
                  }
                </div>
                <div className="dash-filtro-usado-parametros">
                  {boxstate.pv.sucursal.length === 0
                    ? boxstate.pv.adr.map(s => capitalizeWords(s.adr)).join(', ')
                    : boxstate.pv.sucursal.map(s => capitalizeWords(s.sucursal)).join(', ')
                  }
                </div>
              </div>
              <div className="dash-filtro-usados-asesor">
                <div className="dash-filtro-usado-titulo"> Asesor: </div>
                <div className="dash-filtro-usado-parametros">
                  {boxstate.pv.vendedor.length === 0
                    ? "Todos"
                    : boxstate.pv.vendedor.map(s => capitalizeWords(s.vendedor)).join(', ')
                  }
                </div>
              </div>
            </div>
            <TablaUnidadesScorecardGerente
              boxstate={boxstate}
              data={data}
              initialStateboxfiltros={initialStateboxfiltros}
            />
          </div>
        )
          : mostrarTImportes === true ? (
            // <div className="hola">
            <div className="dash-tabla-container">
              <div className="dash-filtro-usados-container">
                <div className="dash-filtro-usados-sucursal">
                  <div className="dash-filtro-usado-titulo">
                    {boxstate.pv.sucursal.length === 0
                      ? "Adr: "
                      : "Sucursal:"
                    }
                  </div>
                  <div className="dash-filtro-usado-parametros">
                    {boxstate.pv.sucursal.length === 0
                      ? boxstate.pv.adr.map(s => capitalizeWords(s.adr)).join(', ')
                      : boxstate.pv.sucursal.map(s => capitalizeWords(s.sucursal)).join(', ')
                    }
                  </div>
                </div>
                <div className="dash-filtro-usados-asesor">
                  <div className="dash-filtro-usado-titulo"> Asesor: </div>
                  <div className="dash-filtro-usado-parametros">
                    {boxstate.pv.vendedor.length === 0
                      ? "Todos"
                      : boxstate.pv.vendedor.map(s => capitalizeWords(s.vendedor)).join(', ')
                    }
                  </div>
                </div>
              </div>
              <TablaImportesScorecardGerente
                boxstate={boxstate}
                data={dataImportes}
                initialStateboxfiltros={initialStateboxfiltros}
              />
              {/* </div> */}
            </div>
          ) : mostrarTAUnidades === true ? (
            <DashScorecardGerenteAsesorTable
              datos={dataAsesores}
              boxstate={boxstate}
            />
          ) : mostrarTAImportes === true ? (
            <>
              <TablaGerenteImporteAsesor
                datos={dataAsesores}
                boxstate={boxstate}
              />
              <div className="aviso-dash-miles">Importes expresados en miles de pesos.</div>
            </>
          ) : (
            <p>No hay datos disponibles</p>
          )}

      </PlantillaScreen>
    </div>
  );
};
